import styled from 'styled-components';
import { ScContainer } from '@/styles/common';
import { device } from '@/styles/helpers';

export const ScTopSection = styled.div`
  position: relative;
  min-height: 680px;
  margin-top: -96px;
  padding-top: 88px;
  overflow: hidden;

  ${ScContainer} {
    gap: 3px;
    @media (${device.mobile}) {
      gap: 16px;
    }
  }



  & > .bg {
    object-fit: fill;
    object-position: top center;
    z-index: -1;
    @media (${device.mobile}) {
      object-fit: cover;
      max-height: 680px;
    }
  }

  & > div {
    display: flex;
    flex-direction: column;
    gap: 8px;
    align-items: center;

    @media (${device.mobile}) {
      gap: 28px;
    }
  }

  @media (${device.mobile}) {
    margin-top: -88px;
    padding-top: 73px;
  }
`;
